import React from "react";
import styles from "./ui-element.module.scss";

const Heading = ({ heading, label }) => {
  return (
    <div className={styles.heading_wrapper}>
      {heading && <h4>{heading}</h4>}
      {label && <p>{label}</p>}
    </div>
  );
};

export default Heading;
